import Api from "../apis/Api";

const CollaborationLinkMixin = {
	data() {
		return {
			fetchingCollaborationLink: false
		}
	},
	methods: {
		getCollaborationLink(instanceId) {
			this.fetchingCollaborationLink = true;
			Api.get(`/instances/${instanceId}/collaboration-link`)
				.then(result => {
					if (result.data.url) {
						window.open(result.data.url, '_blank');
					}
				})
				.catch((error) => {
					const errorMsg = Api.getErrorMessage(error);
					this.$store.dispatch("addAlert", {
						success: false,
						errorMessage: errorMsg,
					});
				})
				.finally(() => {
					this.fetchingCollaborationLink = false;
				});
		}
	}
}
export default CollaborationLinkMixin
